import React, {Component} from 'react';
import { Table, Button, Message } from 'semantic-ui-react';
import _ from 'underscore';
import Moment from 'moment';
import { connect } from 'react-redux';

import {
    submitSystemAdminDeleteExcludedClinic
} from '../../../actions';

class SysadminExcludedClinicListTable extends Component {
    state = {
        isSubmitting: false,
        error: false,
        errorMessage: null,
        success: false
    }
    
    render() {
        return (
            <div style={{margin: '1em 0'}}>
                {
                    this.state.error &&
                    <Message negative>
                        <Message.Header>We're sorry - there was an issue</Message.Header>
                        <p>
                            { this.state.errorMessage }
                        </p>
                    </Message>
                }
                <Table celled selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>ID</Table.HeaderCell>
                            <Table.HeaderCell>Excluded Clinic Code</Table.HeaderCell>
                            <Table.HeaderCell>Created</Table.HeaderCell>
                            <Table.HeaderCell>Delete</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            _.map(this.props.excludedClinics, (excludedClinic) => {
                                const {
                                    _id,
                                    code,
                                    created
                                } = excludedClinic;
                                return (
                                    <Table.Row key={_id}>
                                        <Table.Cell>{_id}</Table.Cell>
                                        <Table.Cell>{code}</Table.Cell>
                                        <Table.Cell>{Moment(created).format('DD/MM/YYYY')}</Table.Cell>
                                        <Table.Cell>
                                            <Button 
                                                type="button" 
                                                size="tiny" 
                                                color="red" 
                                                loading={this.state.isSubmitting}
                                                disabled={this.state.isSubmitting}
                                                onClick={() => {
                                                    let ok = window.confirm("Are you sure you want to delete this record from excluded clinics?");
                                                    if (ok) {
                                                        this.setState({
                                                            isSubmitting: true
                                                        });
                                                        this.props.submitSystemAdminDeleteExcludedClinic(
                                                            {accessToken: this.props.user.accessToken, id: _id},
                                                            (result, error) => {
                                                                this.setState({
                                                                    isSubmitting: false
                                                                });

                                                                if (result) {
                                                                    this.setState({error: false, errorMessage: null, success: true});
                                                                }
                                                                if (error) {
                                                                    this.setState({error: true, errorMessage: error.errorMessage});
                                                                }
                                                            }
                                                        )
                                                }}}>
                                                Delete
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })
                        }
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        excludedClinics: state.systemAdmin.excludedClinics,
    }
}

export default connect(mapStateToProps, {
    submitSystemAdminDeleteExcludedClinic
})(SysadminExcludedClinicListTable);